import Vue from 'vue';
import Router from 'vue-router';
import MasterComponent from '@/components/MasterComponent.vue';
import PartnerComponent from '@/components/PartnerComponent.vue';
import OperatorComponent from '@/components/OperatorComponent.vue';
import Login from '@/components/LoginPage.vue';
import store from '../store';
import axios from 'axios';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    { path: '/', name: 'Login', component: Login },
    { path: '/master', name: 'Master', component: MasterComponent, meta: { requiresAuth: true, role: 'MASTER' } },
    { path: '/operator', name: 'Operator', component: OperatorComponent, meta: { requiresAuth: true, role: 'Operator' } },
    { path: '/ntv', name: 'ANDTV', component: PartnerComponent, meta: { requiresAuth: true, role: 'ANDTV' } },
    { path: '/odk', name: 'ODK', component: PartnerComponent, meta: { requiresAuth: true, role: 'ODK' } },
    { path: '/roku', name: 'ROKU', component: PartnerComponent, meta: { requiresAuth: true, role: 'ROKU' } },
    { path: '/comcast', name: 'COMCAST', component: PartnerComponent, meta: { requiresAuth: true, role: 'COMCAST' } },
    { path: '/amazon', name: 'AMAZON', component: PartnerComponent, meta: { requiresAuth: true, role: 'AMAZON' } },
    { path: '/viki', name: 'VIKI', component: PartnerComponent, meta: { requiresAuth: true, role: 'VIKI' } }
  ]
});

router.beforeEach(async (to, from, next) => {
  const authRequired = to.matched.some(record => record.meta.requiresAuth);

  // Get user_email and session_id from the URL.
  const urlParams = new URLSearchParams(window.location.search);
  const userEmail = urlParams.get('user_email');
  const sessionId = urlParams.get('session_id');

  // If userEmail or sessionId is different from the current session, clear the stored session.
  const storedUser = store.getters.userEmail && store.getters.token;
  if (storedUser && (storedUser.userEmail !== userEmail || storedUser.token !== sessionId)) {
    store.dispatch('logout');
  }

  let auth = store.getters.auth;

  // If there is no authentication information and there is authentication information in the URL, attempt authentication.
  if (!auth && userEmail && sessionId) {
    auth = await checkAuth(userEmail, sessionId);
  }

  // Redirect to the Login page if authentication is required and the user is not authenticated.
  if (authRequired && !auth) {
    return next('/');
  }

  // Redirect to the appropriate page based on the authentication status.
  if (auth) {
    if (to.path === '/') {
      if (auth === 'MASTER') {
        return next('/master');
      } else if (auth === 'Operator') {
        return next('/operator');
      } else {
        return next({ name: auth });
      }
    }

    if (auth === 'MASTER' || auth === 'Operator') {
      return next();
    }

    if (auth !== 'MASTER' && auth !== 'Operator') {
      if (to.meta.role === auth) {
        return next();
      } else {
        return next({ name: auth });
      }
    }
  }

  next();
});

async function checkAuth(userEmail, sessionId) {
  try {
    const response = await axios.post('https://api.da.kcpglob.com/api/common/kocowa/sgw/validate_token', {
      user_email: userEmail,
      token: sessionId
    });

    const { valid, auth } = response.data;

    if (valid) {
      const copyAuth = auth || 'Operator'; // Default to 'Operator' if auth is null
      store.dispatch('login', { email: userEmail, token: sessionId, auth: copyAuth });
      return copyAuth;
    }
    return null;
  } catch (error) {
    console.error('Error fetching authentication status:', error);
    return null;
  }
}

export default router;